import React, { FC, useState } from 'react'
import classNames from 'classnames'
import { getStyledElementProps } from '@/utils'
import type { ButtonProps } from './button.d'
import styles from './button.module.scss'

export const Button: FC<ButtonProps> = ({
  fullWidth = false,
  variant = 'primary-light',
  type = 'button',
  size = 'md',
  disabled,
  ...props
}) => {
  const [isPressed, setIsPressed] = useState(false)
  const styledProps = getStyledElementProps(
    props,
    classNames(styles['root'], styles[variant], styles[`size-${size}`], {
      'not-allowed': disabled,
      'pui-sizing-full-width': fullWidth,
      active: isPressed,
    })
  )

  const handleMouseDown = () => {
    setIsPressed(true)
  }
  const handleMouseUp = () => {
    setIsPressed(false)
  }

  return (
    <button
      type={type}
      {...styledProps}
      disabled={disabled}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
    />
  )
}
